<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { setCookie,getCookie } from '@/utils/common'
  export default {
    name: 'app',
    mounted() {
  //    let userInfo  =  getCookie('userInfo')
  //    if(userInfo){;
  //      this.saveDataAndRoute(this,userInfo)
  //    }
  },
//  methods: {
//    saveDataAndRoute(self,data){
////        res.data.data.roleId,res.data.data.userName,res.data.data.roleName,res.data.data.lastLoginTime,res.data.data.listFirstMenu,res.data.data.listsecondMenu,res.data.data.listThreeMenu
//      setCookie('userName',data.userName);
//      setCookie('lastLoginTime', data.lastLoginTime);
//      setCookie('listFirstMenu',data.listFirstMenu);
//      setCookie('listsecondMenu',data.listsecondMenu);
//      setCookie('listThreeMenu',data.listThreeMenu)
//
////
////      self.$store.commit('SET_USER', data.userName)
////      self.$store.commit('SET_ROLE', data.roleName)
////      self.$store.commit('SET_LOGINTIME', data.lastLoginTime)
////      self.$store.commit('SET_FIRSTMENU', data.listFirstMenu)
////      self.$store.commit('SET_SECONDMENU', data.listsecondMenu)
////      self.$store.commit('SET_THREEMENU', data.listThreeMenu)
//////      self.$notify({
////        title: '登录成功',
////        type: 'success',
////        duration: 800,
////        showClose: false,
////      })
////      setTimeout(function () {
//        self.$router.push({path: '/main'})
////      }, 800)
//    },
//  }
}
</script>

<style lang='scss'>
  @import './style/common.scss';
  #app{
    width: inherit;
    height: inherit;
    display: flex;
    // flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue